import styled from 'styled-components';

export const Flex = styled.div`
	display: flex;
`;

/** A vertical flex layout which will grow to full width of its container */
export const FlexColumn = styled(Flex)`
	flex-direction: column;
	width: 100%;
`;

/** A vertical flex layout which will grow to full width of its container, with center-aligned children */
export const FlexColumnCentered = styled(FlexColumn)`
	align-items: center;
`;

/** A horizontal flex layout */
export const FlexRow = styled(Flex)`
	flex-direction: row;
`;

/** A horizontal flex layout where the row items will be aligned to the top of the row */
export const FlexRowTop = styled(FlexRow)`
	align-items: flex-start;
`;

/** A horizontal flex layout where the row items will be aligned to the BOTTOM of the row */
export const FlexRowBottom = styled(FlexRow)`
	align-items: flex-end;
`;

/** Used to put some margin spacing on the left/right sides, but not on the top */
export const Inset = styled.div`
	margin-left: 1rem;
	margin-right: 1rem;
`;

/**
 * Used to put some margin spacing on the top/bottom sides, but not on the left or right.
 */
export const VerticalInset = styled.div`
	margin-top: 1rem;
	margin-bottom: 1rem;
`;

/** Display a row of content with items are evenly distributed in the line, center aligned */
export const SpaceBetweenRow = styled(FlexRow)`
	width: 100%;
	align-items: center;
	justify-content: space-between;
`;

/** Display a row of content with items are evenly distributed in the line, center aligned */
export const SpaceBetweenRowSmallGap = styled(SpaceBetweenRow)`
	gap: 0.5rem;
`;

/** Display a row of content with items are evenly distributed in the line, center aligned, with a gap of 1rem */
export const SpaceBetweenRowGap = styled(SpaceBetweenRow)`
	gap: 1rem;
`;

export const SpaceBetweenWrapRow = styled(SpaceBetweenRow)`
	flex-wrap: wrap;
	gap: 0.5rem;
`;

/** Display a row of content with items evenly spaced around in the line, center aligned */
export const SpaceAroundRow = styled(FlexRow)`
	width: 100%;
	align-items: center;
	justify-content: space-around;
`;

/** A horizontal flex layout where the items are all centre aligned, expanding to the full width of the container */
export const CentredFlexRow = styled(FlexRow)`
	width: 100%;
	align-items: center;
	justify-content: center;
`;

export const SpaceEvenRow = styled(FlexRow)`
	align-items: center;
	justify-content: space-evenly;
`;
export const SpaceEvenRowSmallGap = styled(SpaceEvenRow)`
	gap: 0.5rem;
`;

/** A horizonal row where there is a 1rem gap between items  */
export const FlexRowSpaced = styled(FlexRow)`
	gap: 1rem;
`;

/** A horizonal row where there is a 1rem gap between items, with items top-aligned */
export const FlexRowTopSpaced = styled(FlexRowSpaced)`
	align-items: flex-start;
`;

export const FlexWrapRowSpaced = styled(FlexRowSpaced)`
	flex-wrap: wrap;
`;

export const FlexRowSpacedLarge = styled(FlexRowSpaced)`
	gap: 2rem;
`;

export const FlexColumnSpaced = styled(FlexColumn)`
	gap: 1rem;
`;

export const FlexColumnSpacedLarge = styled(FlexColumn)`
	gap: 2rem;
`;

export const FlexColumnSmallSpaced = styled(FlexColumn)`
	gap: 0.5rem;
`;

export const FlexColumnMiniSpaced = styled(FlexColumn)`
	gap: 0.25rem;
`;

export const FlexRowSmallSpaced = styled(FlexRow)`
	gap: 0.5rem;
`;
export const FlexWrapRowSmallSpaced = styled(FlexRowSmallSpaced)`
	flex-wrap: wrap;
`;
export const FlexRowCenterAligned = styled(FlexRow)`
	align-items: center;
`;
export const FlexRowCenterJustify = styled(FlexRow)`
	justify-content: center;
`;

export const FlexRowCentered = styled(FlexRowCenterJustify)`
	align-items: center;
	height: 100%;
`;
export const FlexRowSmallSpacedCentered = styled(FlexRow)`
	gap: 0.5rem;
	align-items: center;
`;

export const FlexRowSpacedCentered = styled(FlexRow)`
	gap: 1rem;
	align-items: center;
`;

export const FlexWrapRowSpacedCentered = styled(FlexRowSpacedCentered)`
	flex-wrap: wrap;
`;

export const FlexColumnFitContent = styled(FlexColumn)`
	width: fit-content;
`;

/** A toolbar used to right-align the buttons, with a gap */
/** Renamed this as it's not only used for toolbars */
export const FlexRowSpacedRightAligned = styled(FlexRow)`
	justify-content: flex-end;
	gap: 1rem;
	width: 100%;
`;

/**A horizontal row where the items are left-aligned */
export const FlexRowLeftAligned = styled(FlexRow)`
	justify-content: flex-start;
`;

export const VerticalContent = styled(FlexColumnSpaced)`
	padding: 0.5rem 1rem 0 1rem;
`;

export const EllipsisSpan = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
`;
/** A full-height padded flex column designed for drawers that have navigation buttons at the bottom.*/
export const DrawerFlexColumn = styled(FlexColumn)`
	padding: 1rem;
	height: 100%;
`;
